import {
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
} from './actions';

const initialState = {
  open: false,
  label: '',
  type: '',
  delay: 3000,
  onEnd: null,
  onStart: null,
  button: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_SNACKBAR: {
      return {
        ...state,
        ...action.payload,
        open: true,
      };
    }
    case HIDE_SNACKBAR:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
}